import * as React from 'react';
import { USERNAME } from '../../../../constants/UrlParams';
import { authorizeFlow } from '../../../../services/authorize/AuthorizeService';
import { FlowType } from '../../../../services/userflow/UserFlowService';

interface BootstrapPageProps {
  flow: FlowType;
  location: Location;
}

class BootstrapPage extends React.PureComponent<BootstrapPageProps, {}> {
  public componentDidMount() {
    // get param used for analytics if present
    const extraParams = {};
    const urlParams = new URLSearchParams(this.props.location.search);
    this.addParamFromHash(extraParams, urlParams, 'cid');
    this.addParamFromHash(extraParams, urlParams, USERNAME);
    authorizeFlow(this.props.flow, extraParams);
  }

  public render() {
    return null;
  }

  private addParamFromHash(extraParams: any, urlParams: URLSearchParams, paramName: string) {
    const urlParam = urlParams.get(paramName);
    if (urlParam) {
      extraParams[paramName] = urlParam;
    }
  }
}

export { BootstrapPage };
